export default "__VITE_ASSET__BM2hKr$c__"